import React from 'react'
import EventCleaningHero from './EventCleaningHero'
import EventCleaningContent from './EventCleaningContent'
import EventCleaningServices from './EventCleaningServices'
import EventCleaningTrustSection from './EventCleaningsection'
import EventCleaningTransform from './EventCleaningTransform'
import Footer from '../../Footer/Footer'








function EventCleaningCorporate() {
    return (
        <div>
            <EventCleaningHero/>
            <EventCleaningContent/>
            <EventCleaningServices/>
            <EventCleaningTrustSection/>
            <EventCleaningTransform/>
            <Footer/>
            
        </div>
    )
}

export default EventCleaningCorporate
